import * as React from "react";
import {
  List, Datagrid, TextField, BooleanField, Show, SimpleShowLayout, Edit, Create, SimpleForm,
  TextInput, BooleanInput, required, FunctionField,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { FrDateField } from "../../components/FrDateField";
import { TechInfo } from "../../components/ui";
import { fmtDate } from "../../utils/format";

// FormationDTO : id, title, subtitle, description, link, center, type,
// format, duration, priceLabel, imageUrl, startDateMillis, endDateMillis,
// featured, published, createdAt, updatedAt.
// GET /formations?includeDrafts=true (admin) : brouillons inclus — sinon
// le BO ne voyait que les formations publiées. Filtres : type, center
// (liste complète, sans pagination backend).
const filters = [
  <TextInput key="type" source="type" label="Type" alwaysOn />,
  <TextInput key="center" source="center" label="Centre" />,
];

const Form = () => (
  <SimpleForm>
    <TextInput source="title" label="Titre" validate={required()} fullWidth />
    <TextInput source="subtitle" label="Sous-titre" fullWidth />
    <TextInput source="description" label="Description" multiline minRows={4} fullWidth />
    <TextInput source="type" label="Type" />
    <TextInput source="center" label="Centre" />
    <TextInput source="format" label="Format" />
    <TextInput source="duration" label="Durée" />
    <TextInput source="priceLabel" label="Prix (libellé)" />
    <TextInput source="link" label="Lien" fullWidth />
    <TextInput source="imageUrl" label="URL de l'image" fullWidth />
    <BooleanInput source="featured" label="Mise en avant" />
    <BooleanInput source="published" label="Publiée" />
  </SimpleForm>
);

export default {
  list: () => (
    <List filters={filters}>
      <Datagrid rowClick="show">
        <TextField source="title" label="Titre" />
        <TextField source="type" label="Type" />
        <TextField source="center" label="Centre" />
        <TextField source="format" label="Format" />
        <FunctionField label="Dates" render={(r) => r?.startDateMillis ? `${fmtDate(r.startDateMillis)}${r?.endDateMillis && fmtDate(r.endDateMillis) !== fmtDate(r.startDateMillis) ? ` → ${fmtDate(r.endDateMillis)}` : ""}` : "—"} />
        <TextField source="priceLabel" label="Prix" />
        <BooleanField source="published" label="Publiée" />
        <BooleanField source="featured" label="En avant" />
        <FrDateField source="createdAt" label="Créée le" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="title" label="Titre" />
        <TextField source="subtitle" label="Sous-titre" />
        <TextField source="description" />
        <TextField source="type" label="Type" />
        <TextField source="center" label="Centre" />
        <BooleanField source="published" label="Publiée" />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
  edit: () => <Edit mutationMode="pessimistic"><Form /></Edit>,
  create: () => <Create><Form /></Create>,
};
